import axiosInstance from "../../api/axiosConfig";

export const getCategories = (params: { limit?: number; page?: number }) => {
  return axiosInstance.get("/sample-categories", { params });
};
